package br.com.duoma.duomaproducao.viewmodel

import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.auth.providers.builtin.Email
import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.auth.Auth
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

data class AuthState(
    val isLoggedIn : Boolean  = false,
    val isLoading : Boolean = false,
    val isFailure : Boolean = false
)



class LoginViewModel {
    val state = MutableStateFlow(AuthState())
    val scope = CoroutineScope(Dispatchers.Default)
    private val supabase = createSupabaseClient(
        "https://scyhqoipdrdncmehgtng.supabase.co",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNjeWhxb2lwZHJkbmNtZWhndG5nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI4NjcyMjAsImV4cCI6MjA3ODQ0MzIyMH0.5Q5iFT9Ri4xljBHo05JrtO1vaKNgQIIZinEArrUOlRQ"
    ) {
        install(Auth)
    }

    fun login(password : String) {
        scope.launch {
            try {
                state.value = state.value.copy(isLoading = true, isFailure = false)
                supabase.auth.signInWith(
                    Email
                ) {
                    this.password = password
                    email = "comercial@duomagenda.local"
                }
                state.value = state.value.copy(isLoggedIn = true)
            } catch (e : Exception) {
                state.value = state.value.copy(isFailure = true, isLoading = false)
            }
        }
    }
}
